import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import Typography from 'ui/components/typography'
import Link from 'ui/components/link'

import useStyles from './styles'

const ServiceTerms = ({ handleClose, data: name }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const image =
    name === 'plana'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifaplana_zen.png'
      : name === 'por-uso'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifa_poruso.png'
      : name === 'noche'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifa_noche.png'
      : name === 'digital-gas'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifa_digital_gas.png'
      : name === 'digital-luz'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifa_digital_luz.png'
      : name === 'digital-noche'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifa_digital_noche_luz.png'
      : name === 'digital-moving'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_tarifa_digital_moving_luz.png'
      : name === 'seguro-proteccion-facturas'
      ? '//naturgy-zapotek-pro.s3-eu-west-1.amazonaws.com/public_images/ico_SPF.png'
      : ''

  const conditionsUrl = t(`entity-${name}-general-url`)
  return (
    <>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h4" color="secondary">
          {t(`entity-${name}-title`)}
        </Typography>
        <Typography component="h4" variant="h2" color="secondary">
          {t(`entity-${name}-subtitle`)}
        </Typography>
        {image !== '' ? <img className={classes.logo} src={image} alt={`${t(`entity-${name}-title`)} logo`} /> : null}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box mt={1} mb={4}>
          <div dangerouslySetInnerHTML={{ __html: t(`entity-${name}-terms`) }} />
        </Box>
        {conditionsUrl && (
          <Box mb={1}>
            <Link iconLeft variant="link" color="secondary" href={conditionsUrl}>
              {t('generalConditions')}
            </Link>
          </Box>
        )}
        {/* <Link iconLeft variant="link" color="secondary" href="#">
          {t('particularConditions')}
        </Link> */}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button color="secondary" variant="contained" onClick={handleClose}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </>
  )
}

export default ServiceTerms
